import { connect } from 'react-redux';
import React, { useState, useEffect } from 'react';
import lodash from 'lodash';
import styles from './SideNav.scss';
import { Link } from 'react-router';
import classnames from 'classnames';
import LifecycleIndicator from 'components/common/Study/LifecycleIndicator';
import MissingDetailIcon from '../../../components/common/MissingDetailIcon/index';

export const SideNav = (props) => {
    const getIndex = () => {
        if (props.activeIndex) {
            return props.activeIndex();
        }

        return 0;
    };

    return (
        <nav className={styles.sidebar} data-cy="SideNav">
            {
                props.header
                    ? <h1 className={styles.sidebarHeader} data-cy="SideNav-header">{props.header}</h1>
                    : null
            }
            {
                props
                    .links
                    .map(
                        (link, index) =>
                            lodash.isArray(link.children) ?
                                <SubMenu
                                    key={index}
                                    location={props.location}
                                    title={link.title}
                                    links={link.children}
                                />
                                :
                                SideNavLink(
                                    index,
                                    link,
                                    index === getIndex(),
                                    props.isMissingDetail
                                )
                    )
            }
        </nav>
    );
};

const SubMenu = ({ links, title, location }) => {
    const [expanded, setExpanded] = useState(false);

    useEffect(() => {
        const isExpanded = lodash.some(links, link => location.pathname.includes(link.to));
        if (expanded !== isExpanded) {
            setExpanded(isExpanded);
        }
    }, [location.pathname]);

    const toggleExpanded = () => {
        setExpanded(state => !state);
    };

    return (
        <div data-cy="SideNav-SubMenu">
            <div onClick={toggleExpanded}
                data-cy="SideNav-toggleExpanded" className={classnames(
                    styles.entry,
                    {
                        [styles.link]: true,
                        [styles.active]: false,
                        [styles.inactive]: true,
                    },
                )}>
                {title}
                <FolderExpandArrow expanded={expanded} />
            </div>
            <div className={styles.offset}>
                {
                    expanded && links.map(
                        (link, index) => SideNavLink(
                            index,
                            link,
                            location.pathname.includes(link.to),
                        ))
                }
            </div>
        </div>
    );
};

const FolderExpandArrow = ({ expanded }) => {
    const iconName = expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right';
    return (
        <span className={styles.arrow}>
            {iconName}
        </span>
    );   
};

const SideNavLink = (index, link, selected, isMissingDetail) => (
    <div
        className={styles.entry}
        key={index}>
        <Link
            to={link.to}
            className={classnames(styles.link,
                { [styles.active]: selected, [styles.inactive]: !selected, })
            }
        >
            {link.title}
            {!!link.pill &&
                <LifecycleIndicator
                    className={classnames(styles.lifecycleIndicator, styles.lifecycleIndicatorBackground)}
                    title={link.pill}
                    withBackground={true}
                />
            }
            {
                link.useEmptyDetailIcon && isMissingDetail && (
                    <MissingDetailIcon />
                )
            }
        </Link>
        
    </div>
);

export default connect(state => {
    return {
        isMissingDetail: lodash.get(state, 'study.isMissingDetail', false),
    };
}, {})(SideNav);
